import Vue from 'vue'
import Vuex from 'vuex'

import { users } from './userActionAndMutations'
import clubs from './clubs'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    users,
    clubs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js